import React, { useState, useEffect } from 'react';
import { 
  ArrowForward,
} from '@mui/icons-material';

import { Button } from '@mui/material';

interface Props {
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export default function NextButton({ 
  disabled = false,
  label = "",
  onClick 
}: Props) {
  const [is_disabled, setDisabled] = useState(disabled);

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  const className =`${is_disabled ? " disabled" : ""}`;

  if (label === "") {
    return (
      <ArrowForward className={ disabled ? "gray" : "clickable"}
        onClick={() => { 
          if (!disabled) {
            onClick();
          }
        }}
      />
    );
  } else {
    return (
      <Button
        className={className}
        disabled={disabled} 
        onClick={() => { 
          if (!disabled) {
            onClick();
          }
        }}
        variant="contained" color="primary">
        <ArrowForward/>&nbsp;{ label }
      </Button>
    );
  }
}
